import { InputField, MyCheckbox, TextareaField } from 'components';
import InfoTooltip from '../../../components/InfoTooltip';
import { formatDate } from 'helper/dateFormat.js';
import { getCurrency, numberFormat } from 'helper/numberFormat.js';
import { isInteger } from 'lodash';
import React, { useEffect } from 'react';
import { DateFormetContext } from '../../../app/App.js';
import { CheckFloatValue } from '../../../utils/functions.js';

const Review = ({ ...props }) => {
  const formik = props;
  const currency = getCurrency();

  console.log('formik: ', formik.values);
  const total = formik.values?.subtotal_amount;
  const discount = formik.values?.discount;
  const discount_type = formik.values?.discount_type;
  const totaldiscountpercentage = total - (discount / 100) * total;
  const totaldiscountCalculated = CheckFloatValue(totaldiscountpercentage)
    ?.toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const totaldiscountDollar = total - (discount ?? 0);
  const totaldiscountDCalculated = CheckFloatValue(totaldiscountDollar)
    ?.toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');


  const [payloadData, setPayloadData] = React.useState("")

  useEffect(() => {
    if (formik?.values?.accounts) {
      const values = formik?.values?.accounts?.map(obj => obj.amount);
      const displayValues = values.join(' / ');
      setPayloadData(displayValues)
    }
  }, [formik.values])


  return (
    <div className="batch-review batch-billing-review">
      <div className="mb-7">
        Charge {formik.values?.accountsCount ?? 0} Accounts
      </div>
      <div className="review-row">
        <div className="mb-4">For</div>
        <div className="batch-name-title">
          {formik.values?.batch_name ?? '-'}
        </div>
      </div>
      <div className="review-row">
        <div className="mb-4">Amount</div>
        <div style={{
          width: formik.values?.batch_type === 'previous_amount' ? "500px" : '',
          display: formik.values?.batch_type === 'previous_amount' && 'flex',
          justifyContent: formik.values?.batch_type === 'previous_amount' && 'end'
        }}>{currency}
          {formik.values?.batch_type === 'previous_amount'
            ? payloadData
            : numberFormat({number:+formik.values?.amount, decimal:2, style: 'decimal'})}
        </div>
      </div>
      {formik.values?.discount ? (
        <div className="review-row">
          <div className="mb-4">Discount</div>
          <div>
            {formik.values?.discount_type === '$' ? currency : ''}
            {numberFormat({number:+formik.values?.discount, decimal:2, style: 'decimal'})}
            {formik.values?.discount_type === '%' ? '%' : ''}
          </div>
        </div>
      ) : (
        ''
      )}
      <hr className="hr-div" />
      <div className="review-row ">
        <div className="subtotal mb-5">Subtotal</div>
        <div className="subtotal">
          {currency}
          {formik.values?.batch_type === "previous_amount"
            ? numberFormat({number:formik.values?.total_previous_amount, decimal:2, style: 'decimal'})
            : discount && discount_type === '%'
              ? totaldiscountCalculated
              : totaldiscountDCalculated}
        </div>
      </div>
      <div className="review-row">
        <div className="mb-5">Due Date</div>
        <div>
          {formatDate({date:formik.values?.due_date, formatType: "defaultWithUTC"})}
        </div>
      </div>
      <div className="col-sm-12 px-0 mt-8">
        <InputField
          {...{
            formik,
            title: 'Charge Description (will show on the member’s statement)',
            name: 'description',
            placeholder: 'Family Membership for 2022, with 10% discount ',
            style: { resize: 'none' },
            batchreview: 'batchreview',
            value: formik.values?.description,
          }}
        />
      </div>
      <div className="col-sm-12 px-0">
        <TextareaField
          {...{
            formik,
            title: "Add Note",
            name: `receipt_note`,
            placeholder: "Note text",
            style: { resize: "none" },
            value: formik?.values?.receipt_note,
          }}
        />
      </div>
      <div className="pb-5" style={{ display: 'flex', alignItems: 'center' }}>
        <MyCheckbox
          name="comment_receipt"
          title="Comment on receipt"
          handlechange={(event) => {
            formik.setFieldValue("comment_receipt", event.target.checked);
          }}
          checked={formik?.values?.comment_receipt}
        />
        <InfoTooltip text="Show the note above on the receipt sent to the payer, instead of keeping it internal only." style={{ marginLeft: '6px', marginBottom: '8px' }} />
      </div>
    </div>
  );
};

export default Review;
